<template>
 <div>
  <div id="eIMessageTagParent">
    <div id="eITime">{{record['datetime']}}</div>
    <!-- （1：等级红包，2：瓜分红包，3：登录红包） -->
    <!-- <div v-if="record['type'] === '1'" id="eItype">等级红包</div>
    <div v-else-if="record['type'] === '2'" id="eItype">瓜分红包</div>
    <div v-else-if="record['type'] === '4'" id="eItype">现金兑换</div>
    <div v-else id="eItype">登录红包</div> -->
    <div id="eItype">{{ record['typename'] }}</div>
    <div v-if="record['type'] === '4'" id="eIMoney" style="color:red">-{{record['amount']}}元</div>
    <div v-else id="eIMoney">{{record['amount']}}元</div>
    <div id="eIState">成功</div>
  </div>
  <HR style="border:1 dashed #987cb9;" width="95%" color=#DCDCDC SIZE=1></HR>
 </div>
</template>

<script>
 export default {
    // 声明属性，需要从父组件中通过 v-bind:time="" 和 v-bind:money="" 传递参数值过来
    props: {
      record:null,
    },
   data () {
     return {

     }
   },
   components: {

   }
 }
</script>

<style>
#eIMessageTagParent{
  margin-left: 5px;
  margin-right: 5px;
  display: flex;
  margin-top: 20px;
}
  
#eITime{
  flex: 2;
  display: flex;
  justify-content: center; /*水平居中*/
  align-items: Center; /*垂直居中*/
  font-weight: bold;
  color: #505050;
  font-size: xx-small;
  line-height: auto;
  text-align: center;
}
#eItype{
  flex: 1;
  display: flex;
  justify-content: center; /*水平居中*/
  align-items: Center; /*垂直居中*/
  font-weight: bold;
  color: #505050;
  font-size: xx-small;
  line-height: auto;
  text-align: center;
}
#eIMoney, #eIState{
  flex: 1;
  display: flex;
  justify-content: center; /*水平居中*/
  align-items: Center; /*垂直居中*/
  font-size: xx-small;
  font-weight: bold;
  color: #8BCD9F;
  line-height: auto;
  text-align: center;
}
 
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/mine/rebateTypeMoney/cashout/receivelog/ReceiveRecordItem.vue